"use client";

import PasswordResetForm from "@/components/auth/password-reset-form";

export const dynamic = "force-dynamic";

export default function ResetPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-card-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <PasswordResetForm />
      </div>
    </div>
  );
}
